module.exports = __webpack_public_path__ + "static/rhia-logo-3d10735a844b466145ad057d5ada3111.png";